/**
 * @param props.color : a hex color to set stroke or fills color of svg path
 * @param props.className : a tailwind class the would be implemented on span tag
 * @param props.strokeWidth : set the strokeWidth with px css
 */

interface PersonProps {
  color?: string
  className?: string
  strokeWidth?: string
}

const ChecklistCircle = (props: PersonProps) => {
  const { color = '#364152' } = props

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM11.7071 6.70711C12.0976 6.31658 12.0976 5.68342 11.7071 5.29289C11.3166 4.90237 10.6834 4.90237 10.2929 5.29289L7 8.58579L5.70711 7.29289C5.31658 6.90237 4.68342 6.90237 4.29289 7.29289C3.90237 7.68342 3.90237 8.31658 4.29289 8.70711L6.29289 10.7071C6.68342 11.0976 7.31658 11.0976 7.70711 10.7071L11.7071 6.70711Z"
        fill={color}
      />
    </svg>
  )
}

export default ChecklistCircle
